export const mobileSummaryStyle = {
    elementStyle: {
        fontSize: 16,
        lineHeight: "24px"
    },
    labelStyle: {
        fontSize: 14,
        lineHeight: "20px",
    }
};

export const summaryStyle = {
    elementStyle: {
        fontSize: 16,
        lineHeight: "24px",
        width: "50%"
    },
    labelStyle: {
        fontSize: 14,
        lineHeight: "20px",
        width: "50%"
    }
};

export const summaryElementLabelStyle = {
    alignItems: "center",
    margin: "unset",
    padding: 10,
    borderRadius: 4,
};


// WEBPACK FOOTER //
// ./src/components/tradingPreferences/styles.ts